const getViewModelCartRows = (lineItems, currency) => {
  return lineItems.map((lineItem) => {
    let productId;
    let sku;
    switch (lineItem.type) {
      case "prescription-glasses":
        productId = lineItem.frame.productId;
        sku = lineItem.frame.sku;
        break;
      default:
        productId = lineItem.productId;
        sku = lineItem.sku;
    }
    return {
      productId,
      unitPrice: `${lineItem.price.unit.gross / 100}`,
      quantity: lineItem.quantity,
      currency,
      sku
    };
  });
};
export {
  getViewModelCartRows
};
//# sourceMappingURL=get-viewmodel-cart-rows.js.map
